import { Box, Typography } from '@mui/material';
import { MapPin } from 'lucide-react';

function ProductReferenceCard({ product }) {
  if (!product?.name) return null;

  return (
    <Box
      sx={{
        mt: { xs: 4, sm: 6 },
        pt: { xs: 4, sm: 5 },
        borderTop: '1px solid rgba(74, 106, 74, 0.15)',
      }}
    >
      <Typography
        variant="caption"
        sx={{
          display: 'block',
          color: 'text.secondary',
          textTransform: 'uppercase',
          letterSpacing: '0.12em',
          fontWeight: 600,
          mb: 2,
        }}
      >
        Referencia de compra
      </Typography>
      <Box
        sx={{
          display: 'flex',
          flexDirection: { xs: 'column', sm: 'row' },
          alignItems: { xs: 'flex-start', sm: 'center' },
          gap: { xs: 2, sm: 3 },
        }}
      >
        {product.image && (
          <Box
            component="img"
            src={product.image}
            alt={product.name}
            sx={{
              width: 72,
              height: 72,
              objectFit: 'cover',
              borderRadius: 1.5,
              flexShrink: 0,
            }}
          />
        )}
        <Box>
          <Typography sx={{ color: 'text.primary', fontWeight: 600 }}>
            {product.name}
          </Typography>
          {product.origin?.location && (
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mt: 0.75 }}>
              <MapPin size={16} color="#4a6a4a" />
              <Typography sx={{ color: 'text.secondary', fontSize: '0.9rem' }}>
                {product.origin.location}
              </Typography>
            </Box>
          )}
        </Box>
      </Box>
    </Box>
  );
}

export default ProductReferenceCard;
